import React, { CSSProperties, ComponentProps } from "react";

import "./TooltipButton.scss";
import AlertWarningIcon from "../../icons/AlertWarningIcon";
import GhostButton from "../GhostButton/GhostButton";

interface TooltipButtonProps extends ComponentProps<"button"> {
  iconStyles?: CSSProperties;
  size?: number;
}

function TooltipButton({
  iconStyles,
  className = "",
  size = 20,
  ...restProps
}: TooltipButtonProps) {
  return (
    <GhostButton
      className={`tooltip-btn ${className}`}
      aria-label="view more info"
      {...restProps}
    >
      <AlertWarningIcon width={size} height={size} style={iconStyles} />
    </GhostButton>
  );
}

export default TooltipButton;
